import { Box, Flex } from "@rebass/grid/emotion";
import React from "react";
import Icon from "react-icons-kit";
import Card from "../Card";
import { trophy } from "react-icons-kit/fa/trophy";
import { tag } from "react-icons-kit/fa/tag";
import { clockO } from "react-icons-kit/fa/clockO";
import styled from "@emotion/styled";
import ReferenceImage from "../ReferenceImage";

const ListIcon = styled(Icon)`
  margin-right: 10px;
  opacity: 0.8;
`;

const Item = styled.div`
  margin-bottom: 15px;
  margin-left: 15px;
`;

const References = ({ data }) => (
  <>
    {data.edges.map((reference, i) => (
      <Card my={3} key={i} collapsed>
        <Flex flexWrap="wrap" alignItems="center">
          <Box width={[1, 2 / 5]} mb={[4, 0]}>
            <ReferenceImage
              fluid={reference.node.frontmatter.image.childImageSharp.fluid}
            />
          </Box>
          <Box width={[1, 3 / 5]} pl={[0, 4]}>
            <h3>
              {reference.node.frontmatter.location} ·{" "}
              {reference.node.frontmatter.type}
            </h3>
            {reference.node.frontmatter.difficulty && (
              <Item>
                <ListIcon size={30} icon={trophy} />
                Schwierigkeitsgrad: {reference.node.frontmatter.difficulty}
              </Item>
            )}
            {reference.node.frontmatter.time && (
              <Item>
                <ListIcon size={30} icon={clockO} />
                Verkaufszeit: {reference.node.frontmatter.time}
              </Item>
            )}
            {reference.node.frontmatter.price && (
              <Item>
                <ListIcon size={30} icon={tag} />
                Verkaufspreis: {reference.node.frontmatter.price}
              </Item>
            )}
            {reference.node.html && (
              <p dangerouslySetInnerHTML={{ __html: reference.node.html }} />
            )}
          </Box>
        </Flex>
      </Card>
    ))}
  </>
);

export default References;
